<template>
  <div class="AppLoadingMask">
    <div class="AppLoadingContent">
      <app-spinner
        :component="component"
        :animation-duration="animationDuration"
        :size="size"
        :color="color"
      />
      <p v-if="tips" class="tips">
        {{ tips }}
      </p>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'AppLoading'
});

const props = defineProps({
  component: {
    type: String,
    default: 'SelfBuildingSquareSpinner'
  },
  animationDuration: {
    type: Number,
    default: 5000
  },
  color: {
    type: String,
    default: '#c30a14'
  },
  size: {
    type: Number,
    default: 40
  },
  tips: {
    type: String,
    default: null
  }
});
</script>

<style lang="scss">
  .AppLoadingMask {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: $white;
    transition: opacity .3s;
    z-index: 9;

    &.fullscreen {
      position: fixed;
      z-index: 2500;
      background-color: $white;
    }

    .AppLoadingContent {
      position: absolute;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
    }

    .tips {
      color: $red;
      font-weight: 700;
      font-size: .16rem;
      padding: .1rem;
      text-align: center;
    }

    &.translucence {
      background: rgba(255, 255, 255, .7);
    }
  }
</style>
